<template>
  <el-dialog
      @close="closeDialog"
      class="add"
      :visible.sync="estimatetimeVisible"
      width="400px"
      title="评审"
  >
    <div class="container" >
      <el-form ref="responseForm" :model="responseForm" label-width="100px">
        <el-row>
          <el-col :span="24">
            <el-form-item
                label="预计解决时间"
                size="small"
                :rules="[{ required: true, message: '请选择预计解决时间' }]"
                prop="estimate_time"
            >
              <el-date-picker
                  v-model="responseForm.estimate_time"
                  type="date"
                  placeholder="选择日期"
                  value-format="yyyy-MM-dd"
                  format="yyyy-MM-dd"
                  :picker-options="pickerOptions0"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
           
        </el-row>
        <el-row>
          <el-col :span="24">
             <el-form-item
                label="版本号"
                size="small"
                :rules="[ { required: true, message: '请输入版本号' }]"
                prop="version"
            >
                <el-input
                      clearable
                      placeholder="请输入版本号"
                      size="small"
                      v-model="responseForm.version"
                  >
                  </el-input>
             </el-form-item>
           </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item size="small">
              <el-button size="small" type="primary" @click="save"
              >保存</el-button
              >
              <el-button size="small" @click="closeDialog"
              >关闭</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
  data() {
    return {
      responseForm: {
        estimate_time: '',
        version: '',
      },
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
    };
  },
  methods: {
    /**
     * 关闭对话框
     */
    closeDialog() {
      this.$emit("update:estimatetimeVisible", false);
    },
    selectProj(){
      oaApi.lastversions({project_id: this.tableItem.project_id}, "get").then(res => {
          if (res) {
              if (res.code == 200) {
                  this.responseForm.version = res.data.version
              }
          }
      });
    },
    save() {
      this.$refs["responseForm"].validate((valid) => {
        if (valid) {
          oaApi
              .workOrdersUpdateStatus(
                  {
                    id: this.tableItem.id,
                    status: 10,
                    estimate_time : this.responseForm.estimate_time,
                    version : this.responseForm.version,
                    is_response : 1
                  },
                  "post"
              )
              .then((res) => {
                this.responseForm.estimate_time = null;
                this.responseForm.version = '';
                this.$message.success(`响应成功`);
                this.closeDialog();
                this.$parent.workOrdersList();
              });
        }
      });
    },
  },
  props: {
    estimatetimeVisible: Boolean,
    tableItem: Object
  },
  watch: {
        estimatetimeVisible: {
            handler(val) {
                this.selectProj();
            },
        },
    },
};
</script>
<style lang="scss">
.add {
  .el-dialog__body {
    padding: 20px 40px;
  }
  .el-steps {
    margin-bottom: 20px;
  }
  .el-select,
  .el-date-editor {
    width: 100%;
  }
  .el-form-item {
    .el-form-item__content {
      .el-radio {
        margin: 0;
        width: 100px;
      }
    }
  }
  .container {
    margin-top: 10px;
    .seccussImg {
      width: 80px;
      margin-top: 18px;
    }
    .seccussText {
      font-size: 18px;
      font-weight: bold;
      line-height: 2;
      margin-top: 18px;
    }
    .tableSchool,
    .tableHealth {
      .el-form-item--small.el-form-item {
        margin-bottom: 0;
      }
    }
  }
}
</style>
